import { displayToast, sendAppsignalError } from "../modules/utils";
import LineChart from "./line_chart";

export default class DashboardFilter {
  constructor(node) {
    this.element = node;
    this.contentWrappers = this.element.querySelectorAll(".js-content-wrapper");
    this.dateFilterElement = this.element.querySelector(".js-filter-element");
    this.pdfButton = this.element.querySelector(".js-pdf-button");

    this.url = new URL(this.element.dataset.endpointUrl, window.location.origin);
    this.currentUrl = new URL(window.location.href);
    this.pdfUrl = new URL(this.pdfButton.href, window.location.origin);

    this.initialize();
  }

  initialize() {
    this.url.searchParams.set("period", this.dateFilterElement.value);
    this.fetchContent();

    this.dateFilterElement.addEventListener("datepicker-change", (e) => {
      this.url.searchParams.set("period", e.target.value);
      this.currentUrl.searchParams.set("period", e.target.value);
      this.pdfUrl.searchParams.set("period", e.target.value);

      this.pdfButton.href = this.pdfUrl.href;

      window.history.pushState({}, "", this.currentUrl);

      this.fetchContent();
    });

    window.addEventListener("popstate", () => {
      this.url.searchParams.set("period", this.dateFilterElement.value);
      this.fetchContent();
    });
  }

  fetchContent() {
    this.contentWrappers.forEach((contentWrapper) => {
      contentWrapper.classList.add("is-loading");
    });

    fetch(this.url, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status === 200) {
          return response.json();
        }

        throw new Error("Something went wrong");
      })
      .then((data) => {
        this.contentWrappers.forEach((contentWrapper) => {
          contentWrapper.innerHTML = this.determineContent(data, contentWrapper.id);
          window.Beyuna.initClasses(contentWrapper);
          contentWrapper.classList.remove("is-loading");
        });

        new LineChart(this.element.querySelector("[data-js='line-chart']"), data.chartData);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorMessage);
        sendAppsignalError(e, "DashboardFilter", {
          response: this.response,
        });
      });
  }

  determineContent(data, id) {
    const { distributors, customers, chart, shop } = data;

    switch (id) {
      case "distributors":
        return distributors;
      case "customers":
        return customers;
      case "chart":
        return chart;
      case "shop":
        return shop;
      default:
        throw new Error("Something went wrong");
    }
  }
}
